import React from 'react';
import {View, StyleSheet, TouchableOpacity, Text} from 'react-native';
import {useGradeUpgrade} from '../../../context/GradeUpgradeContext';

const UpgradeTest = () => {
  const {testUpgrade} = useGradeUpgrade();

  const handleTestUpgrade = async (type: 'stage' | 'grade' | 'term') => {
    console.log('测试升级按钮被点击:', type);
    await testUpgrade?.(type);
  };

  return (
    <View style={styles.container}>
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => handleTestUpgrade('stage')}>
        <Text>测试升学段</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => handleTestUpgrade('grade')}>
        <Text>测试升年级</Text>
      </TouchableOpacity>
      <TouchableOpacity
        style={styles.buttonContainer}
        onPress={() => handleTestUpgrade('term')}>
        <Text>测试升学期</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 16,
    backgroundColor: 'white',
  },
  buttonContainer: {
    marginVertical: 8,
    padding: 16,
    borderRadius: 8,
    backgroundColor: '#f0f0f0',
  },
});

export default UpgradeTest;
